/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Imagealt1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_imagealt1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft quarterly sales dashboard with a table, column chart and pie chart`)
};

const zh_gc_search_guides_gridcraft_vs_excel_imagealt1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 季度销售看板，包含数据表、柱状图和饼图`)
};

/**
* | output |
* | --- |
* | "GridCraft quarterly sales dashboard with a table, column chart and pie chart" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Imagealt1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_imagealt1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Imagealt1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Imagealt1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_imagealt1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_imagealt1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_imagealt1 as "gc.search_guides.gridcraft_vs_excel.imageAlt" }